import React from 'react';
import BulmaContainer from 'react-bulma-components/lib/components/container';

export const Container = ({ children, ...props }) => (
  <BulmaContainer {...props}>{children}</BulmaContainer>
);

export default Container;
